import packageInfo from '../../package.json';

export const environment = {
  production: false,

  backofficeVersion: packageInfo.version,

  apiAdminBaseUrl: 'https://tradigames.api.admin.vydegames.com/',

  apiAdminKey: '348b23f1-0d0c-4dca-bb82-79ad98da6e61',

  gameAssetsBaseUrl: 'https://game-assets-dev.wcgfoperation.com/',
};
